const cardMember = {
  seeMyCard: 'See my card',
  changeMyCard: 'Change my card',
  addToMyWallet: 'Add to my {{brand}} Wallet',
  valueOfPoints: 'Value of ${{amount}}',
  pointsFamiliplus: 'Familiplus Points',
  nbrPoints: '{{count}} points',
  nbrPointsShort: '{{count}} pts',
  youHaveHarvested: 'You have collected',
  inTheLastXDays: 'in the last {{count}} days',
};

const staticBanner = {
  donation: 'Make a donation to Opération Enfant Soleil',
  downloadApp: 'Download the Familiprix mobile application',
  discoverFamiliplus: 'Find out more about the Familiplus points program',
};

const OES = {
  availablePoints: '{{points}} points (${{value}}) available',
  greeting: 'Make a donation to Opération Enfant Soleil',
  howManyPoints: 'How many points would you like to give?',
  pointsValue: 'Donation value in dollars: ${{value}}',
  consentLabel:
    'I authorize Familiprix to withdraw points from my balance to offer its value in dollars to Opération Enfant Soleil.',
  taxLabel: 'Note that no tax receipt will be issued following this donation.',
  legalTerms: 'Familiplus program terms and conditions.',
  donate: 'Confirm',
  consent: 'You have to give your consent to donate points',
  maxPoints: 'You cannot give more points than the total number of points on your card.',
  minPoints: 'You must enter a number of points greater than 0.',
  donationSuccess:
    'Thank you for your donation of {{points}} points / {{value}} dollars to Opération Enfant Soleil. Your support is truly appreciated!',
};

const transactions = {
  recentTitle: 'Recent transactions',
  noResult: 'No transaction found.',
  seeAll: 'See all transactions',
  allTitle: 'All my transactions',
  backToSummary: 'Back',
  fetchDataFailed:
    'An error occurred while retrieving your transactions. Please try again in a few minutes. If the problem persists, please contact our customer service at experienceclient@familiprix.com.',
};

const NotMember = {
  earnPointsWeekly: 'Earn points every week!',
  weeklyDraw: 'Take advantage of a weekly points draw via the Familiplus app for a chance to win up to 10,000 points.',
  saveWithMemberPrice: 'Save with our Member pricing',
  getCompetitivePrice: 'Get great prices, exclusively for Familiplus members.',
  accumulatePointsQuickly: 'Accumulate points quickly',
  accumulatePointsEverywhere: 'Earn points on almost all of your in-store purchases.',
  becomeMemberAndBenefit: 'Become a Familiplus member and enjoy many benefits',
  becomeMember: 'Become a member',
  bigPlus: "It's a big plus",
  accumulatePointsAndStartEarning:
    'Earn points on almost all your purchases and earn reward dollars quickly. Create or complete your profile in minutes!',

  seeAllBenefits: 'See all benefits',
};

const familiplusPage = {
  cardMember,
  staticBanner,
  OES,
  transactions,
  NotMember,
};

export default familiplusPage;
